import React, { useEffect, useState } from "react";
import CloudStorage from "../../../../../../CloudStorage/CloudStorage";
import { useDispatch, useSelector } from "react-redux";
import { getMinePosts } from "../../../../../../redux/posts/action";
import { useNavigate } from "react-router-dom";
import PostNotFound from "../../../../../CustomComponents/AllLoader/PostNotFound";
import { useRouteBaseStateContext } from "../../../../../../Context/RouteBaseStateContext";
import GetRemainDays from "./MineActiveProject/ProjectModels/GetRemainDays";
import GetStatus from "./MineActiveProject/ProjectModels/GetStatus";
import DeadlineComponents from "../../../../../Common/DeadlineComponents";

export default function PostedContests() {
  const { setMyorderRecentprojectroute, setMyorderActiveprojectroute, setMyAllProjectListroute } =
    useRouteBaseStateContext();
  const navigate = useNavigate();
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const dispatch = useDispatch();
  const postlistmine = useSelector(
    ({ posts: { postlistmine } }) => postlistmine,
  );

  useEffect(() => {
    dispatch(getMinePosts(1));
  }, [dispatch]);

  const deactivatedContests = Array.isArray(postlistmine)
    ? postlistmine.filter((item) => item.status == 1)
    : [];
  const activeContests = Array.isArray(postlistmine)
    ? postlistmine.filter((item) => item.status == 2)
    : [];
  const completedContests = Array.isArray(postlistmine)
    ? postlistmine.filter((item) => item.status == 3)
    : [];
  return (
    <>
      <div className="posted-project">
        <div className="d-flex justify-content-between align-items-center">
          <h4>Posted Post & Browse Projects (PBP) ({deactivatedContests.length})</h4>
          <button className="buttons background-button"
            onClick={() => {
              navigate(`/${lan}/dashboard/myorders/project/listings`);
              setMyAllProjectListroute('paymentpendingprojects')
            }
            }
          >
            View More
          </button>
        </div>
        <div className="recent-post">
          {deactivatedContests.length === 0 ? (
            <PostNotFound title={"No Post Found"} />
          ) : (
            deactivatedContests.slice(0, 4).map((item, index) => (
              <div key={index} className="post-back">
                <div className="col-md-5">
                  <h3>{item.title}</h3>
                  <div className="post-img">
                    <p>
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/project/hourglass.svg`}
                        alt=""
                      />
                      <DeadlineComponents milestones={false} posts={item} />
                    </p>
                  </div>
                </div>
                <div className="activity col-md-4">
                  <h6>Activity</h6>
                  <div className="post-img">
                    <p>
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/myorders/proposal.svg`}
                        alt=""
                      />
                      Proposal: {item?.proposal_count}
                    </p>
                    <p>
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/myorders/message.svg`}
                        alt=""
                      />
                      Message: {item?.chat_count}
                    </p>
                  </div>
                </div>
                <button
                  onClick={() => {
                    navigate(
                      `/${lan}/dashboard/myorders/project/recent/${item.id}`,
                    );
                    setMyorderRecentprojectroute("");
                  }}
                  className="btn"
                >
                  View details
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/homepage/right-arrow-orange.svg`}
                    alt=""
                  />
                </button>
              </div>
            ))
          )}
        </div>
        <div className="d-flex justify-content-between align-items-center">
          <h4>Active Post & Browse Projects (PBP) ({activeContests.length})</h4>
          <button className="buttons background-button"
            onClick={() => {
              navigate(`/${lan}/dashboard/myorders/project/listings`);
              setMyAllProjectListroute('activeprojectlist')
            }
            }
          >
            View More
          </button>
        </div>
        <div className="recent-post">
          {activeContests.length === 0 ? (
            <PostNotFound title={"No Post Found"} />
          ) : (
            activeContests.slice(0, 4).map((item, index) => (
              <div key={index} className="post-back">
                <div className="col-md-5">
                  <h3>{item.title}</h3>
                  <GetRemainDays enddate={item?.active_milestone?.ends_on} />
                </div>
                <div className="activity col-md-4">
                  <h6>Active milestone: {item?.active_milestone_count}</h6>
                  <h5>
                    {!item?.active_milestone?.title
                      ? "No Active Milestone"
                      : item?.active_milestone?.title}
                  </h5>
                  <GetStatus status={item?.active_milestone?.status} />
                </div>
                <button
                  onClick={() => {
                    navigate(
                      `/${lan}/dashboard/myorders/project/active/${item.id}`);
                    setMyorderActiveprojectroute("");
                  }}
                  className="btn"
                >
                  Review works
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/homepage/right-arrow-orange.svg`}
                    alt=""
                  />
                </button>
              </div>
            ))
          )}
        </div>
      </div>
    </>
  );
}
